function a(t) {
  if (typeof t != "string")
    return !1;
  try {
    new URL(t);
  } catch {
    return !1;
  }
  return !0;
}
function h(t) {
  if (a(t))
    return t;
}
function y(t) {
  const r = h(t);
  if (r === void 0)
    throw new Error("Not a valid UrlString");
  return r;
}
function c(t) {
  if (typeof t != "string")
    return !1;
  try {
    const r = new URL(t);
    if (r.search !== "" || r.hash !== "")
      return !1;
  } catch {
    return !1;
  }
  return !t.endsWith("/");
}
function g(t) {
  let r = t.length - 1, n = 0;
  for (; r >= -1 && t[r] === "/"; )
    r--;
  for (; n < r && t[n] === "/"; )
    n++;
  return r < 0 ? "" : t.substring(n, r + 1);
}
function d(t) {
  if (typeof t != "string")
    return;
  const r = g(t);
  if (c(r))
    return r;
}
function b(t) {
  const r = d(t);
  if (r === void 0)
    throw new Error("Not a valid BaseUrlString");
  return r;
}
function U(...t) {
  return t.map((r) => g(r).trim()).filter((r) => r !== "").join("/");
}
function $(t) {
  return t.endsWith("/") ? t : `${t}/`;
}
function f(t, r = void 0, n = void 0) {
  let i = "";
  const e = n == null ? void 0 : n.query;
  e !== void 0 && Object.keys(e).length > 0 && (i = `?${new URLSearchParams(e).toString()}`);
  const u = n == null ? void 0 : n.fragment;
  let s = "";
  typeof u == "string" && u !== "" && (s = `#${u}`);
  const l = U(...r || []), o = `${`${t}${l === "" ? "" : "/"}${l}`}${s}${i}`;
  if (!a(o))
    throw new Error(`buildUrl: Built url not a valid url string(${o})`);
  return o;
}
class m {
  constructor(r) {
    this.configuration = r;
  }
  buildUrl(r = void 0, n = void 0) {
    return f(this.configuration.baseUrl, r, n);
  }
  buildBaseUrl(r = void 0) {
    const n = f(this.configuration.baseUrl, r);
    if (!c(n))
      throw new Error(
        `Failed to build BaseUrlString. BaseUrl: ${this.configuration.baseUrl}, pathParts: ${JSON.stringify(r)}`
      );
    return n;
  }
}
export {
  m as SiteUrlBuilder,
  $ as addEndingSlash,
  f as buildUrl,
  c as isBaseUrlString,
  a as isUrlString,
  U as joinUrlPathParts,
  b as toBaseUrlStringOrThrow,
  d as toBaseUrlStringOrUndefined,
  y as toUrlStringOrThrow,
  h as toUrlStringOrUndefined,
  g as trimSlashes
};
